


















import Vue from 'vue'
import Component from 'vue-class-component'
import { getFilePathByKey } from '@/utils/helpers'

@Component({
  props: {
    title: {
      type: String,
      default: ''
    },
    user: {
      type: Object
    }
  }
})
export default class Avatar extends Vue {
  getFilePathByKey: Function = getFilePathByKey;
}
